import { getInstance } from './auth-wrapper'

export const authGuard = (to, from, next) => {
  const authService = getInstance()

  const fn = () => {
    if (authService.isAuthenticated) {
      if (authService.user.profile.permissions.role !== 'admin') {
        if (to?.meta?.super_admin) {
          if (
            authService.user.profile.permissions.organization !== 'vanished'
          ) {
            next({
              name: '404',
              params: {
                resource: 'Resource',
              },
            })
          }
        }
        if (to?.meta?.admin) {
          next({
            name: '404',
            params: {
              resource: 'Resource',
            },
          })
        }
        // if (!authService.user.profile.permissions.features.includes(to.name)) {
        //   next({
        //     name: '404',
        //     params: {
        //       resource: 'Resource',
        //     },
        //   })
      }
      return next()
    }

    authService.loginWithRedirect({
      appState: { targetUrl: to.fullPath },
      organization: 'org_2ANpSKBNwTNFLeYi',
    })
  }

  if (!authService.loading) {
    return fn()
  }

  authService.$watch('loading', (loading) => {
    if (loading === false) {
      return fn()
    }
  })
}
